import type { ReactElement, ReactNode } from "preact/compat";
import { createContext, useContext } from "preact/compat";
import type { GtmService } from "~/frontend-common/gtm.ts";

const GtmServiceContext = createContext<GtmService | undefined>(undefined);

type GtmServiceProviderProps = {
	readonly gtm: GtmService;
	readonly children: ReactNode;
};

function GtmServiceProvider({
	gtm,
	children,
}: GtmServiceProviderProps): ReactElement {
	return (
		<GtmServiceContext.Provider value={gtm}>
			{children}
		</GtmServiceContext.Provider>
	);
}

function useGtmService() {
	const gtm = useContext(GtmServiceContext);
	if (!gtm) {
		throw new Error("No gtm service context");
	}
	return gtm;
}

export { GtmServiceProvider, useGtmService };
